module.exports = __webpack_public_path__ + "media/images/games/35gender/mechanic-dea39c518216c2e1da2ba47b6b955657.png";